import { useTranslations } from 'next-intl';

/**
 * Helpers for translating string-enum members.
 * Enum values must already be the i18n keys
 * (e.g. "UserStatus_ACTIVE").
 */
export const useEnumTranslations = () => {
  const t = useTranslations();

  const getEnumLabel = (enumName: string, enumValue: string) => {
    return t(`${enumName}_${enumValue}`);
  };

  const getEnumOptions = (enumName: string, enumObj: Record<string, string>) => {
    return Object.values(enumObj).map((value) => ({
      value,
      label: t(`${enumName}_${value}`),
    }));
  };

  return { getEnumLabel, getEnumOptions, t };
};
